import { computed, onMounted, watch } from 'vue'
import useGet from '../../../core/composables/api/useGet'
import { useRoute } from 'vue-router'
import type { Dialog } from '@/core/models/dialog/dialog'
import type { Skill } from '@/core/models/skill'
import type { FeedbackTopicType } from '@/core/models/feedback-topic'

export const useCoacheeProfile = () => {
  const route = useRoute()

  const coacheeId = computed(() => route.params.id as string)

  const endpoint = computed(() => `coaching/coachee/${coacheeId.value}/profile`)

  const { data, load, status } = useGet<Profile>(endpoint)

  onMounted(() => load())

  watch(coacheeId, () => {
    load()
  })

  return {
    data,
    status,
  }
}

export interface Profile {
  readonly superpower: Skill | null
  readonly feedbackTopics: ReadonlyArray<{
    id: string
    title: string
    icon: string
    type: FeedbackTopicType
  }>
}
